















import { Vue, Component } from 'vue-property-decorator';
import { List } from 'vant';
import NewsItem from '@/components/next/NewsItem.vue';
import { fetchNewslist } from '@/api/api';
import { getNews } from '../api';
Vue.use(List);
@Component({
  components: {
    NewsItem,
  },
})
export default class News extends Vue {
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;

  goDetail(a: any) {
    if (window.udid && a.dataType !== 7 && a.dataType !== 5) {
      const msg = {
      action: 'mJump',
      data: JSON.stringify({
        dt: a.dataType,
        cid: a.classId || a.columnId,
        nid: a.id,
        url: a.targetUrl,
        title: a.title || a.navTitle,
        })
      };
      window.handleMessage(JSON.stringify(msg));
    } else {
      location.href = a.targetUrl;
    }
  }
  onLoad() {
    getNews(this.page, '9980').then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (res.data.data.length === 0 || res.data.data[0].list.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data.data[0].list];
    }
    this.loading = false;
  }
}
